/* eslint-disable jira/filename-case */

import type { ProductPermissionGates } from '@atlassian/jira-shared-types/src/product-permission-gates.tsx';
import {
	CORE,
	SOFTWARE,
	PRODUCT_DISCOVERY,
	SERVICE_DESK,
	CUSTOMER_SERVICE,
} from '@jira/platform__application-editions/src/application-key.tsx';

type MetaGetter = (name: string) => string | null;

type ProductPermissionGatesRaw = {
	[applicationName: string]: boolean;
};

// Fallback to true(not allowed) if product does not exist. This makes sense, because the tenant has no product.
// If user tries to somehow access the feature they are not supposed to access, it should be blocked.
const parseProductPermissionGates = (
	productPermissionGatesRaw: ProductPermissionGatesRaw,
): ProductPermissionGates => ({
	core:
		typeof productPermissionGatesRaw[CORE] === 'boolean' ? productPermissionGatesRaw[CORE] : true,
	software:
		typeof productPermissionGatesRaw[SOFTWARE] === 'boolean'
			? productPermissionGatesRaw[SOFTWARE]
			: true,
	serviceDesk:
		typeof productPermissionGatesRaw[SERVICE_DESK] === 'boolean'
			? productPermissionGatesRaw[SERVICE_DESK]
			: true,
	productDiscovery:
		typeof productPermissionGatesRaw[PRODUCT_DISCOVERY] === 'boolean'
			? productPermissionGatesRaw[PRODUCT_DISCOVERY]
			: true,
	customerService:
		typeof productPermissionGatesRaw[CUSTOMER_SERVICE] === 'boolean'
			? productPermissionGatesRaw[CUSTOMER_SERVICE]
			: true,
});

const defaultProductPermissionGates: ProductPermissionGates = {
	core: true,
	software: true,
	serviceDesk: true,
	productDiscovery: true,
	customerService: true,
};

const getProductPermissionGates = (getMetaImpl: MetaGetter): ProductPermissionGates => {
	try {
		const productPermissionGatesRaw = JSON.parse(
			getMetaImpl('ajs-product-permission-gates') || '{}',
		);
		return parseProductPermissionGates(productPermissionGatesRaw);
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// oxlint-disable-next-line no-console
		console.warn(`Error parsing product permission gates from tenant context: ${error}`);
		return defaultProductPermissionGates;
	}
};

export default getProductPermissionGates;
